export default __webpack_public_path__ + "media/components/Profile/left-e2fc564380ab7d16fd030cd7c1e0d8c4.png";